import { Component, OnInit, inject, model } from '@angular/core';

import { FormatService } from '../../../services';

@Component({
  selector: 'app-report-footer-standard-text',
  templateUrl: './report-footer-standard-text.component.html',
  styleUrl: './report-footer-standard-text.component.css',
})
export class ReportFooterStandardTextComponent implements OnInit {
  private readonly formatService = inject(FormatService);

  public readonly model = model<any>();

  protected htmlStandardText: string;

  ngOnInit() {
    this.htmlStandardText = this.formatService.multiLineToHtml(this.model()?.standardText);
  }
}
